var _excluded = ["className"],
  _excluded2 = ["className", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable react/prop-types */
import React from 'react';
import clsx from 'clsx';
import { string } from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import { alpha, styled } from '@mui/material/styles';
var StyledTooltip = styled(function (_ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Tooltip, _extends({}, props, {
    classes: {
      popper: className
    }
  }));
})(function (_ref2) {
  var _ref2$theme = _ref2.theme,
    palette = _ref2$theme.palette,
    spacing = _ref2$theme.spacing,
    typography = _ref2$theme.typography;
  return {
    '& .MuiTooltip-tooltip': {
      alignItems: 'center',
      backgroundColor: alpha(palette.common.black, 0.8),
      color: palette.text.contrast,
      display: 'flex',
      fontSize: typography.body2.fontSize,
      minHeight: spacing(3),
      paddingLeft: spacing(),
      paddingRight: spacing(),
      hyphens: 'auto'
    }
  };
});
var SovosTooltip = function SovosTooltip(_ref3) {
  var className = _ref3.className,
    children = _ref3.children,
    rest = _objectWithoutProperties(_ref3, _excluded2);
  var wrappedChildren = typeof children === 'string' ? /*#__PURE__*/React.createElement("span", null, children) : children;
  return /*#__PURE__*/React.createElement(StyledTooltip, _extends({
    className: clsx('sovosTooltip', className)
  }, rest), wrappedChildren);
};
SovosTooltip.propTypes = {
  /**
   * Extend the class name applied to the root element
   */
  className: string
};
SovosTooltip.defaultProps = {
  className: undefined
};
SovosTooltip.baseComponent = {
  name: 'Tooltip',
  link: 'tooltip/'
};
export default SovosTooltip;